export default "__VITE_ASSET__CLQg2BNE__"